export const GENDERS = [
  { full: "g_male", short: "M" },
  { full: "g_female", short: "F" },
];
export const T_SHIRT_SIZES = [
  "X-Small",
  "Small",
  "Medium",
  "Large",
  "X-Large",
  "2X-Large",
];

export const TS_CHECKOUT_COUNTRIES = [
  "us",
  "mx",
  "eu",
  "ch",
  "mt",
  "hr",
  "gb",
  "ca",
  "cc",
  "th",
  "si",
  "in",
  "ae",
  "cr",
  "pt",
  "be",
  "aa",
  "my",
  "ph",
  "cl",
  "ie",
];
export const SUBSCRIPTION_COUNTRIES = [
  "US",
  "CA",
  "GB",
  "ES",
  "FR",
  "DE",
  "IT",
  "SI",
  "GR",
];

// Check-in window: number of days before event start that check-in opens
export const CHECKIN_DAYS_BEFORE = 10;

// BE event field that switches the event to the new check-in flow (anything but true = old flow)
export const CHECKIN_FLOW_FLAG = "ts_checkin_flow_enabled";
